import { SxProps } from "@mui/material";

// Shared base style for all response boxes
const baseBoxStyle: SxProps = {
  textTransform: "capitalize",
  width: "100%",
  textAlign: "center",
  justifyItems: "center",
  borderRadius: "32px",
  fontFamily: "inherit",
  "& span": {
    fontSize: "12px",
    fontWeight: 500,
  },
};

// Variant-specific overrides
export const responseExpertBoxStyle: SxProps = {
  ...baseBoxStyle,
  backgroundColor: "rgba(30, 134, 111, 0.09)",
  color: "#1E866F",
  cursor: "pointer",
};

export const responseAdminBoxStyle: SxProps = {
  ...baseBoxStyle,
  backgroundColor: "rgba(30, 86, 134, 0.1)",
  color: "#1E866F",
  cursor: "pointer",
};

export const sentBoxStyle: SxProps = {
  ...baseBoxStyle,
  width: "85%",
  backgroundColor: "rgba(236, 147, 36, 0.09)",
  color: "#EC9324",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "rgba(236, 147, 36, 0.05)",
  },
  "& span": {
    fontWeight: 600, // override base
  },
};

// Revoked and Declined boxes share background and width
const redBoxBase: SxProps = {
  ...baseBoxStyle,
  width: "85%",
  backgroundColor: "rgba(255, 165, 165, 0.25)",
  "& span": {
    fontWeight: 600,
  },
};

export const revokedBoxStyle: SxProps = {
  ...redBoxBase,
  color: "#e59866",
  "&:hover": {
    backgroundColor: "rgba(255, 165, 165, 0.25)",
  },
};

export const declinedBoxStyle: SxProps = {
  ...redBoxBase,
  color: "#FF5064",
};

// View button style
export const viewBtnStyles: SxProps = {
  textTransform: "capitalize",
  width: "100%",
  fontSize: "14px",
  fontWeight: 500,
  backgroundColor: "#EC9324",
  color: "white",
  borderRadius: "15px",
  padding: "2px 0",
  "&:hover": {
    backgroundColor: "#EC9324",
  },
};
